import moment, { Moment } from 'moment';

// 定义接口
export interface DateShortcutType {
  name: string;
  type: string;
  nameCN: string;
  onClick: () => Array<Moment | null>;
}

export interface ShortcutOptionType {
  [type: string]: DateShortcutType[];
}

export const shortcutOptionContrast = (startDate: string, endDate: string, dateRange:number): ShortcutOptionType => {

  // 日粒度
  let dayArray = [
    {
      name: 'Previous Period',
      nameCN: '上期',
      type: 'prePeriod',
      timeType: 'date',
      onClick: () => {
        const lastPeriodStart = moment(startDate).subtract(dateRange + 1, 'day');
        const lastPeriodEnd = moment(endDate).subtract(dateRange + 1, 'day');
        return [lastPeriodStart, lastPeriodEnd];
      }  
    },
    {
      name: 'Same Period Last Year',
      nameCN: '去年同期',
      type: 'lastPeriod',
      timeType: 'date',
      onClick: () => {
        // 计算去年同期的起始和结束日期
        let lastYearStart = moment(startDate).subtract(1, 'year');
        let lastYearEnd = moment(endDate).subtract(1, 'year');
        // 当前选择的日期范围的天数
        const currentRange = dateRange + 1; // 日期范围的天数
        // 去年同期的天数
        const lastYearRange = lastYearEnd.diff(lastYearStart, 'days') + 1;
        // 如果当前选择的起始日期是闰年的2月29日且去年不是闰年，则调整去年起始日期到3月1日
        if (moment(startDate).isLeapYear() && moment(startDate).month() === 1 && moment(startDate).date() === 29) {
          if (!moment(lastYearStart).isLeapYear()) {
            lastYearStart = moment(lastYearStart).month(2).date(1);
          }
        }
        // 如果去年同期的天数少于当前选择的日期范围，并且当前日期范围包含闰年的2月29日，
        // 则调整去年结束日期以补足天数
        // 示例: 统计日期选择2024-02-27~2024-02~29 :: 去年同期应为2023-02-27~2023-03~01
        if (lastYearRange < currentRange && moment(startDate).isLeapYear() && moment(startDate).month() === 1 && moment(startDate).date() === 29) {
          lastYearEnd = moment(lastYearEnd).add(1, 'day');
        }
        // 如果当前选择的日期范围包含闰年的2月29日到3月1日，
        // 则调整去年结束日期以匹配当前日期范围的天数
        // 示例：统计日期选择2024-02-29~2024-03~01 :: 去年同期应为2023-03-01~2023-03~02
        if (moment(startDate).isLeapYear() && moment(startDate).month() === 1 && moment(startDate).date() === 29 && moment(endDate).month() === 2 && moment(endDate).date() === 1) {
          lastYearEnd = moment(lastYearStart).add(currentRange - 1, 'days');
        }
        // 确保返回的日期范围符合当前选择的日期范围
        const adjustedLastYearEnd = moment(lastYearStart).add(dateRange, 'days');
    
        return [lastYearStart, adjustedLastYearEnd];
      }
    }
    
  ];
  
  // 月粒度
  let monthArray = [
    {
      name: 'Previous period',
      nameCN: '上期',
      type: 'prePeriod',
      timeType: 'month',
      onClick: () => {
        // 计算当前选择的日期范围内的月份数
        const monthDiff = moment(endDate).diff(moment(startDate), 'months') + 1; // 包含起始月
        // 上期的起始日期向前推对应的月份数
        const lastPeriodStart = moment(startDate).subtract(monthDiff, 'months').startOf('month');
        // 上期的结束日期向前推对应的月份数
        const lastPeriodEnd = moment(endDate).subtract(monthDiff, 'months').endOf('month');
  
        return [lastPeriodStart, lastPeriodEnd];
      }
    },
    {
      name: 'Same period last year',
      nameCN: '去年同期',
      type: 'lastPeriod',
      timeType: 'month',
      onClick: () => {
      // 去年同期起始日期和结束日期分别向前推12个月
        const lastYearStart = moment(startDate).subtract(1, 'year').startOf('month');
        const lastYearEnd = moment(endDate).subtract(1, 'year').endOf('month');
        return [lastYearStart, lastYearEnd];
      }
    }
  ];


  if (JSON.stringify(endDate) !== '{}') {
    dayArray = [...dayArray];
    monthArray = [ ...monthArray];
  }
  if (startDate !== '') {
    dayArray = [...dayArray];
    monthArray = [...monthArray];
  }

  return {
    'date': dayArray,
    'month': monthArray,
  };
};
